import emailValidator from 'foundation/js/inputValidators/emailValidator'
import isBoolean from 'foundation/js/inputValidators/isBoolean'
import nameValidator from 'foundation/js/inputValidators/nameValidator'
import phoneValidator from 'foundation/js/inputValidators/phoneValidator'

export default [
    {
        name: 'firstTimeFighter',
        value: false,
        isValid: false,
        validator: isBoolean
    },
    {
        name: 'firstName',
        value: '',
        isValid: false,
        validator: nameValidator
    },
    {
        name: 'lastName',
        value: '',
        isValid: false,
        validator: nameValidator
    },
    {
        name: 'email',
        value: '',
        isValid: false,
        validator: emailValidator
    },
    {
        name: 'phone',
        value: '',
        isValid: false,
        validator: (value) => value === '' || phoneValidator(value)
    },
    {
        name: 'consent',
        value: false,
        isValid: false,
        validator: (value) => value === true
    },
    {
        name: 'fighterNewsletter',
        value: false,
        isValid: false,
        validator: isBoolean
    }
]
